import { render, staticRenderFns } from "./SignupPage2.vue?vue&type=template&id=16cd3343&scoped=true&"
import script from "./SignupPage2.vue?vue&type=script&lang=js&"
export * from "./SignupPage2.vue?vue&type=script&lang=js&"
import style0 from "./SignupPage2.vue?vue&type=style&index=0&id=16cd3343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd3343",
  null
  
)

export default component.exports